import { render } from "./menuSidebar.vue?vue&type=template&id=7b220e5e&scoped=true"
import script from "./menuSidebar.vue?vue&type=script&lang=js"
export * from "./menuSidebar.vue?vue&type=script&lang=js"

import "./menuSidebar.vue?vue&type=style&index=0&id=7b220e5e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b220e5e"]])

export default __exports__